import { UrlCollection } from "../common/url-collection";
import LayoutUserView from "../components/layout/layout-user.view";
import Login from "../modules/login/login.view.jsx";
import ForgotPassword from "../modules/forgot-password/forgot-password.view.jsx";
import ResetPassword from "../modules/reset-password/reset-password.view.jsx";

export const authRoutes = [
    {
        path: UrlCollection.Login,
        component: Login,
        layout: LayoutUserView,
        exact: true,
        isSetActive: false
    },
    {
        path: UrlCollection.ForgotPassword,
        component: ForgotPassword,
        layout: LayoutUserView,
        exact: true,
        isSetActive: false
    },
    {
        path: UrlCollection.ResetPassword,
        component: ResetPassword,
        layout: LayoutUserView,
        exact: true,
        isSetActive: false
    }
];
